export default async function ({ store, redirect, route }) {
  await store.dispatch('globals/getRedirects')

  for (const entry of store.state.globals.redirects) {
    const from = entry.name
    const to = entry.value
    const re = new RegExp(`^${from.replace(/\/$/, '')}\\/?(\\?|$)`)
    if (route.fullPath.match(re)) {
      redirect(to)
    }
  }
}
